import { useAuth } from "../../lib/AuthContext";
import { Lock, Sparkles } from "lucide-react";

// Signup wall: renders content (kept in DOM for SEO) but blurred + non-interactive
// for anonymous visitors, with a centered "register to unlock" call-to-action.
// Unlocks automatically once the user is authenticated.
export const GatedSection = ({ children, title = "Contenu réservé aux membres", subtitle }) => {
  const { user, setAuthOpen } = useAuth();
  // user === null => still loading (show content to avoid flash). user (object) => logged in.
  if (user || user === null) return children;

  return (
    <div className="relative" data-testid="gated-section">
      <div className="pointer-events-none select-none opacity-50 blur-[7px]" aria-hidden="true">
        {children}
      </div>
      <div className="absolute inset-0 z-20 flex items-center justify-center p-6">
        <div className="max-w-md rounded-3xl border border-blue-400/30 bg-[#0B1220]/85 p-8 text-center shadow-2xl backdrop-blur-xl">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-blue-400/40 bg-blue-500/15">
            <Lock size={22} className="text-blue-200" />
          </span>
          <h3 className="mt-5 font-display text-2xl font-800 tracking-tighter text-white">{title}</h3>
          <p className="mt-3 font-body text-sm leading-relaxed text-[#8AA0C0]">
            {subtitle || "Créez votre compte gratuit pour débloquer cette section et explorer toute la plateforme AIBA."}
          </p>
          <button
            data-testid="gated-signup-btn"
            onClick={() => setAuthOpen(true)}
            className="cta-glow mt-6 inline-flex items-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-white transition-all duration-300 hover:bg-blue-500"
          >
            <Sparkles size={14} /> S'inscrire gratuitement
          </button>
          <p className="mt-4 font-mono text-[9px] uppercase tracking-[0.2em] text-[#405060]">Gratuit · Sans carte bancaire</p>
        </div>
      </div>
    </div>
  );
};
